export default {
  lightenRGB(r, g, b, strength) {
    return [Math.floor(r + (255 - r) * strength), Math.floor(g + (255 - g) * strength), Math.floor(b + (255 - b) * strength)];
  },

  /**
   * @param {number[]} colorArray 
   */
  toHex(colorArray) {
    if (!colorArray || colorArray.length != 4 && colorArray.length != 3) {
      throw 'invalid argument: ' + colorArray;
    }

    const ret = "#" + colorArray[0].toString(16) + colorArray[1].toString(16) + colorArray[2].toString(16);

    if (colorArray.length == 4) {
      ret += colorArray[3].toString(16);
    }

    return ret;
  },

  lighten(color, strength) {
    const format = /^\#([0-9abcdef]{3,8})$/i;

    if (!format.test(color)) {
      throw 'color format not supported: ' + color;
    }
    /**
     * @type {string} hex
     */


    const hex = color;
    const rgb = hex.substring(1);

    if (rgb.length == 3) {
      return this.toHex(this.lightenRGB(parseInt(rgb[0], 16) * 17, parseInt(rgb[1], 16) * 17, parseInt(rgb[2], 16) * 17, strength));
    } else if (rgb.length == 6) {
      return this.toHex(this.lightenRGB(parseInt(rgb.substring(0, 2), 16), parseInt(rgb.substring(2, 4), 16), parseInt(rgb.substring(4, 6), 16), strength));
    }
  }

};